import { ComponentProps } from 'react';
import GooglePlaySVG from '@/assets/images/google-play.svg';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const GooglePlay = ({ href, ...props }: Props) => {
    const url = href?.trim();
    if (!url || url === '#') return null;

    return (
        <Layout element="a" href={url} target="_blank" rel="noopener noreferrer" {...props}>
            <GooglePlaySVG width={135} height={40} />
        </Layout>
    );
};
